import React from 'react';

import { css } from '@emotion/css';
import { theme } from 'theme';

export const DailyWorkflowLoadingSkeleton = () => (
  <div
    className={css`
      padding: 24px;
      border: 1px solid ${theme.colors.neutral[300]};
      border-radius: 8px;
      flex: 1 0 400px;
    `}
  >
    <div
      className={css`
        height: 28px;
        width: 60%;
        background: ${theme.colors.neutral[200]};
        border-radius: 4px;
        margin-bottom: 16px;
        animation: pulse 1.5s infinite;
        @keyframes pulse {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
          100% {
            opacity: 1;
          }
        }
      `}
    />
    <div
      className={css`
        height: 18px;
        width: 40%;
        background: ${theme.colors.neutral[100]};
        border-radius: 4px;
        margin-bottom: 24px;
        animation: pulse 1.5s infinite;
      `}
    />
    <div
      className={css`
        height: 120px;
        width: 100%;
        background: ${theme.colors.neutral[100]};
        border-radius: 8px;
        margin-bottom: 24px;
        animation: pulse 1.5s infinite;
      `}
    />
    <div
      className={css`
        height: 18px;
        width: 30%;
        background: ${theme.colors.neutral[100]};
        border-radius: 4px;
        margin-bottom: 8px;
        animation: pulse 1.5s infinite;
      `}
    />
    <div
      className={css`
        height: 18px;
        width: 50%;
        background: ${theme.colors.neutral[100]};
        border-radius: 4px;
        margin-bottom: 8px;
        animation: pulse 1.5s infinite;
      `}
    />
    <div
      className={css`
        height: 18px;
        width: 40%;
        background: ${theme.colors.neutral[100]};
        border-radius: 4px;
        animation: pulse 1.5s infinite;
      `}
    />
  </div>
);
